/*eslint-disable*/
import { mapState } from 'vuex';
import api from "../../api";

export default {
    methods: {
        areActionsAllowed (profile) {
            if (this.user.isSuperadmin || this.user.isManagerOrSupport) {
                return true;
            }
            let workingSchools = profile.schools.filter(school => school.isBillingActive ? school.account.status : true);
            let flag = false;
            if (!workingSchools.length) {
                return flag;
            }
            this.user.schools.forEach(school => {
                if (school.account.status && !!workingSchools.find(workingSchool => workingSchool.id === school.id)) {
                    flag = true;
                    return flag;
                }
            });
            return flag;
        },
        requestGenerateExcel () {
            this.isShowDownloadButton = false;
            this.isExcelLoading = true;
            this.api.exportList(this.searchParams).then(data => {
                if(!this.linkExcelFile) {
                    this.$echo.private(`prepare-report-excel.${this.user.id}`).listen('PrepareReportExcel', e => {
                        this.linkExcelFile = this.getExcelExportUrl() + e.url;
                        this.isExcelLoading = false;
                        if (e.url) {
                            this.isShowDownloadButton = true;
                        }
                        if (e.error) {
                            this.$toasted.error(e.error);
                        }
                    });
                }
            });
        }
    },
    computed: {
        ...mapState({
           user: state => state.auth.user,
        }),
        areSchoolsBlocked () {
            if (this.user.isSuperadmin || this.user.isManagerOrSupport) {
                return false;
            }
            if (this.user.schools.some(school => school.studentPayed)) {
                let isUserAccountBlocked = this.user.account && !this.user.account.status;
                let commonPayedSchools = this.user.schools.filter(school => !school.studentPayed);
                let areSchoolsBlocked = commonPayedSchools.every(school => school.isBillingActive ? !school.account.status : false);
                return isUserAccountBlocked && areSchoolsBlocked;
            }
            return this.user.schools.every(school => school.isBillingActive ? !school.account.status : false);
        },
        isTeacherBillingAndSchoolAccountStatusInactive() {
            if (this.user.isSuperadmin || this.user.isManagerOrSupport) {
                return false;
            }
            return this.user.schools.every(school => !school.account.status && school.isTeachersBillingActive)
        },
        blockedAccesses () {
            if (this.user.isSuperadmin) {
                return [];
            }
            let blockedSchools = this.user.schools.filter(school => school.isBillingActive ? !school.account.status : false);
            let activeSchools = this.user.schools.filter(school => school.isBillingActive ? school.account.status : true);
            let blockedGradesAccesses = [];
            blockedSchools.forEach(school => !school.studentPayed && blockedGradesAccesses.push(...school.grades.map(grade => grade.access)));
            if (this.user.account && !this.user.account.status && this.user.grades) {
                let studentPayedGrades = this.user.grades.filter(grade => grade.school.studentPayed);
                blockedGradesAccesses.push(...studentPayedGrades.map(grade => grade.access));
            }
            blockedGradesAccesses = blockedGradesAccesses.filter((value, index, self) => self.indexOf(value) === index);
            let activeGradesAccesses = [];
            activeSchools.forEach(school => !school.studentPayed && activeGradesAccesses.push(...school.grades.map(grade => grade.access)));
            activeGradesAccesses = activeGradesAccesses.filter((value, index, self) => self.indexOf(value) === index);
            let forbiddenAccesses = [];
            blockedGradesAccesses.forEach(access => {
                if (!activeGradesAccesses.includes(access)) {
                    forbiddenAccesses.push(access);
                }
            });
            return forbiddenAccesses;
        }
    }
}
